import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';
import { withStyles } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';

import Typography from 'Components/UI/Typography';

const styles = theme => ({
  root: {},
  paper: {},
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(1),
  },
  titleHolder: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(1),
  },
  title: {},
  subtitle: {},
  closeButton: {
  },
  content: {
    padding: theme.spacing(0, 2),
  },
});

function Flyout({
  children,
  className,
  classes,
  onClose,
  subtitle,
  title,
  width,
  ...rest
}) {
  return (
    <Drawer
      className={classNames(classes.root, className)}
      classes={{
        root: classes.root,
        paper: classes.paper,
      }}
      onClose={onClose}
      {...rest}
    >
      <Box className={classes.header}>
        <IconButton
          color="primary"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CancelIcon />
        </IconButton>
        <Box className={classes.titleHolder}>
          <Typography
            className={classes.title}
            color="primary"
            variant="h2"
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="body1"
              className={classes.subtitle}
              color="primary"
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      <Box className={classes.content}>{children}</Box>
    </Drawer>
  );
}

Flyout.defaultProps = {
  className: '',
  subtitle: null,
};

Flyout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default withStyles(styles)(Flyout);
